module.exports = __webpack_public_path__ + "static/media/tick.6d78fb1e.svg";